// extracted by mini-css-extract-plugin
export default {"InputGroup":"InputGroup_InputGroup__M5wPG","inline":"InputGroup_inline__5CQy1"};